export default{
    apiUrl:'https://admin.yushen888.com',
    // apiUrl : `${location.origin}`
}